module.exports = __webpack_public_path__ + "assets/img/company6.f89dbccd.png";